import { cannot } from '@/app/helpers'

import { CampaignTemplateType, PartFamily } from './types'

export const canTranscribe = (type: CampaignTemplateType) => {
  switch (type) {
    case CampaignTemplateType.Drip:
    case CampaignTemplateType.VoiceSurvey:
      return true
    case CampaignTemplateType.CATI:
    case CampaignTemplateType.Reminder:
    case CampaignTemplateType.SMSBlast:
    case CampaignTemplateType.SMSSurvey:
    case CampaignTemplateType.VoiceBlast:
    case CampaignTemplateType.WhatsAppSurvey:
    case CampaignTemplateType.Chatbot:
      return false

    default:
      return cannot(type)
  }
}

export const canVoiceTranscribe = (partType: PartFamily) => {
  return partType === PartFamily.WhatsApp
}

export const canCategorize = (type: CampaignTemplateType) => {
  switch (type) {
    case CampaignTemplateType.Drip:
    case CampaignTemplateType.Reminder:
    case CampaignTemplateType.SMSSurvey:
    case CampaignTemplateType.WhatsAppSurvey:
      return true
    case CampaignTemplateType.CATI:
    case CampaignTemplateType.SMSBlast:
    case CampaignTemplateType.VoiceBlast:
    case CampaignTemplateType.VoiceSurvey:
    case CampaignTemplateType.Chatbot:
      return false

    default:
      return cannot(type)
  }
}
